import HeaderItemInfo from 'components/ItemLayout/HeaderItemInfo'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import React, {useContext} from 'react'
import {BsCaretDownFill, BsCaretUpFill,} from 'react-icons/bs'
import {Link} from 'react-router-dom'
import {CustomEditorRenderer} from 'views/AppLocals/custom/CustomRichEditor'
import {FlexCol} from 'views/AppLocals/Templates/ItemTemplate'
import renderCategoryLink from 'views/LandingPage/functions/renderCategoryLink'
import {LayoutContext} from '../../../../components/layouts/Default/LayoutContext'
import useTranslate from '../../../../modules/local/useTranslate'
import {getResponseItems, renderIf} from '../../../Shared'
import {isRawContentEmpty} from '../../../SlateEditor/functions/parseRawContent'
import OrganizationContainerContext from '../OrganizationContainerContext'
import Translate from "../../../../modules/local/Translate";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {useToggle} from "react-use";
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {TbBellRingingFilled} from "react-icons/tb";
import {FaLightbulb} from "react-icons/fa6";
import useAsync from "../../../../modules/asyncCache/useAsync";
import {announcement_gets_Api, timetable_getDetails_Api} from "../../../../apis";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {Avatar} from "antd";
import OrganizationNews from "./OrganizationNews";
import {withProps} from "recompose";
import createPagerFooter from "../../factory/createPagerFooter";
import {AnnouncementTypes} from "../consts/AnnouncementTypes";
import {useChurches} from "../../Church/functions/useChurches";
import {BiSolidChurch} from "react-icons/bi";
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import {OrganizationShopsBlock} from "./OrganizationContactInfo";
import {OrganizationUpcomingEventBlock} from "./OrganizationEventList";
import {PiCalendarCheckFill} from "react-icons/pi";
import dayjs from "dayjs";
import getTitle from "../../../../helpers/getTitle";

function renderIntervalWeekly(value) {
    let label = ''
    switch (value) {
        case '1000000':
            label = 'monday'
            break
        case '0100000':
            label = 'tuesday'
            break
        case '0010000':
            label = 'wednesday'
            break
        case '0001000':
            label = 'thursday'
            break
        case '0000100':
            label = 'friday'
            break
        case '0000010':
            label = 'saturday'
            break
        case '0000001':
            label = 'saturday'
            break
        default :
            label = null
            break
    }
    return label ? label : null
}

function renderInterval(value, viewOnly = false) {
    let label
    switch (value) {
        case 'D':
            label = 'daily'
            break
        case 'W':
            label = 'weekly'
            break
        case 'M':
            label = 'monthly'
            break
        default :
            if (viewOnly) return null;
            label = null
            break
    }
    return (
        <Translate>
            {(t) => t(label)}
        </Translate>
    )
}

export const OrganizationUpcomingTimetableBlock = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)

    const {response, isLoading} = useAsync({
        apiInfo: timetable_getDetails_Api,
        values: {owner_type: 'organization', owner_id: organization?.id},
    })

    const items = getResponseItems(response)

    const today = dayjs().startOf('day')
    const endOfTomorrow = dayjs().add(1, 'day').endOf('day')

    const upcoming = _.chain(items || [])
        .filter(e => {
            const st = dayjs(e?.start_time)
            return st.isAfter(today) && st.isBefore(endOfTomorrow) && !dayjs(e?.end_time).isBefore(dayjs())
        })
        .sortBy(e => dayjs(e?.start_time).valueOf())
        .value()

    if (!upcoming.length && !isLoading) return null

    return (
        <WrapperBlockSider
            title="upcoming schedule"
            titleColor="text-indigo-700"
            borderLeft={isLg}
            borderTop={!isLg}
            icon={<PiCalendarCheckFill size={18} className="text-indigo-500"/>}>
            <div className="flex flex-col gap-2">
                {isLoading ? (
                    <div className="h-10 background-100 rounded-lg animate-pulse"/>
                ) : (
                    upcoming.map((e, i) => {
                        const {start_time, end_time, location_address, notes} = e ?? {}
                        const isToday = dayjs(start_time).isSame(dayjs(), 'day')
                        return (
                            <div key={i} className="flex items-start gap-3 px-2 py-2 rounded-xl border border-indigo-100 bg-indigo-50">
                                <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-indigo-100 flex flex-col items-center justify-center">
                                    <span className="font-extrabold text-sm text-indigo-700 leading-none">
                                        {dayjs(start_time).format('HH:mm')}
                                    </span>
                                    <span className="text-3xs text-indigo-400 mt-0.5">
                                        {isToday ? t('today') : t('tomorrow')}
                                    </span>
                                </div>
                                <div className="flex-1 min-w-0 flex flex-col gap-0.5">
                                    <span className="font-semibold text-sm text-indigo-800 leading-snug">
                                        {getTitle(e)}
                                    </span>
                                    {location_address && (
                                        <span className="text-xs text-color-400 italic">{location_address}</span>
                                    )}
                                    <span className="text-xs text-indigo-400">
                                        {dayjs(start_time).format('HH:mm')} – {dayjs(end_time).format('HH:mm')}
                                    </span>
                                    {notes && (
                                        <span className="text-xs italic text-color-400 max-lines-1">{notes}</span>
                                    )}
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
        </WrapperBlockSider>
    )
}

export const OrganizationIntroduction = ({}) => {

    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)
    const {description} = organization ?? {}
    const history = useHistory()

    if (!description) return null

    return (
        <WrapperBlockSider
            title="charism & mission"
            titleColor="text-indigo-700"
            borderLeft={isLg}
            borderTop={!isLg}
            icon={<FaLightbulb size={18} className="text-indigo-400"/>}>
            <div className="flex flex-col gap-3">
                <div className="text-sm text-color-200 tracking-wide leading-relaxed max-lines-3">
                    {description}
                </div>
                <span
                    className="flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                    onClick={() => {
                        scrollToRow('contentOrg')
                        history.push(getLinkToDetail(organization) + '/overview')
                    }}>
                    <span className="text-xs italic">{t('see more')}</span>
                    <FiChevronsRight size={13} className="my-auto"/>
                </span>
            </div>
        </WrapperBlockSider>
    )
}

export const OrganizationChurchOrAnnouncement = () => {

    const {isLg} = useContext(LayoutContext)
    const t = useTranslate()
    const {organization} = useContext(OrganizationContainerContext)
    const {association} = organization ?? {}
    const {church} = association ?? {}
    const [isToggle, toggle] = useToggle()

    const {response} = useAsync({
        apiInfo: announcement_gets_Api,
        values: {owner_type: 'organization', owner_id: organization?.id, status: 1}
    })
    const announcements = getResponseItems(response)
    const hasMore = Number(announcements?.length) > 2
    const visibleAnnouncements = (announcements || []).slice(0, isToggle ? Number(announcements?.length) : 2)

    const {churchModal, showDialog} = useChurches({notifyListeners: {}})

    return (church || Number(announcements?.length) > 0) && (
        <WrapperBlockSider
            title="announcements"
            titleColor="text-blue-700"
            borderLeft={isLg}
            borderTop={!isLg}
            icon={<TbBellRingingFilled size={18} className="text-blue-500"/>}>
            <div className="flex flex-col gap-3">

                {/* Church row */}
                {church && (
                    <div className="flex items-center gap-2">
                        <Avatar
                            size={46}
                            src={association?.church?.photo}
                            icon={<BiSolidChurch size={22} className="text-indigo-500"/>}
                            className="flex flex-center bg-indigo-50 rounded-md"
                        />
                        <div className="flex flex-col flex-1">
                            <Link to={getLinkToDetail(church)} className="no-underline">
                                <p className="font-bold text-base text-color-000 tracking-wide">
                                    {association?.church?.name}
                                </p>
                            </Link>
                            <span
                                onClick={() => showDialog(church)}
                                className="font-medium text-xs text-color-300 hover:text-blue-700 tracking-wide cursor-pointer">
                                {t('view mass times')}
                            </span>
                        </div>
                    </div>
                )}

                {/* Divider chỉ khi có cả church lẫn announcements */}
                {church && Number(announcements?.length) > 0 && (
                    <div className="border-b border-dashed"/>
                )}

                {/* Announcement list — không lặp header mỗi item */}
                {Number(visibleAnnouncements.length) > 0 && (
                    <div className="flex flex-col gap-3">
                        {visibleAnnouncements.map((e, i) => {
                            const typeItem = _.find(AnnouncementTypes, {value: e?.type_code || e?.type_label})
                            return (
                                <DrawDialog
                                    key={i}
                                    width={600}
                                    title={
                                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                            {t('announcements')}
                                        </div>
                                    }
                                    closable={true}
                                    component={
                                        <div
                                            key={i}
                                            className="px-3 py-2 flex flex-col border border-color-50 shadow-sm rounded-xl cursor-pointer hover:shadow-md">
                                            {/* Type badge — nhỏ gọn, không uppercase to */}
                                            <div className="mb-1 flex items-center gap-1">
                                                {typeItem?.icon}
                                                <span className="text-xs font-semibold text-blue-600 tracking-wide">
                                            {e?.type_label}
                                        </span>
                                            </div>
                                            {/* Title — bỏ uppercase, dễ đọc hơn */}
                                            <span
                                                className="font-bold text-sm text-color-100 hover:text-primary tracking-wide leading-snug">
                                        {e?.title}
                                    </span>
                                            <div
                                                className="mt-1 text-xs text-color-300 tracking-wide whitespace-pre-line max-lines-2">
                                                {e?.content}
                                            </div>
                                        </div>
                                    }>
                                    {(isToggle, toggle) => isToggle && (
                                        <div className="flex flex-col gap-4">

                                            <div className="flex flex-col gap-3">
                                                <div className="flex flex-col gap-1">
                                    <span className="font-medium text-color-200 tracking-wide">
                                        {t('title')}
                                    </span>
                                                    <span
                                                        className="ml-3 font-bold text-lg text-gray-700 tracking-wide">
                                        {e?.title}
                                    </span>
                                                    {e?.type && (
                                                        <span
                                                            className="ml-3 font-semibold text-sm text-blue-700 italic tracking-wide">
                                            {t(e?.type)}
                                        </span>
                                                    )}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                    <span className="font-medium text-color-200 tracking-wide">
                                        {t('content')}
                                    </span>
                                                    <div
                                                        className="ml-3 text-color-300 tracking-wider whitespace-pre-line">
                                                        {e?.content}
                                                    </div>
                                                    {e?.shared_url && (
                                                        <Link
                                                            to={getLinkToDetail(e?.shared_url)}
                                                            target="_blank"
                                                            className="ml-3 text-color-200 italic no-underline">
                                                            {e?.shared_url}
                                                        </Link>
                                                    )}
                                                    {(e?.time_open || e?.time_close) && (
                                                        <DoubleValueItem
                                                            showIcon={true}
                                                            labelFirst={t('from date')}
                                                            valueFirst={formatSimplifyDate(e?.time_open, 'medium')}
                                                            labelSecond={t('to date')}
                                                            valueSecond={formatSimplifyDate(e?.time_close, 'medium')}
                                                            className="ml-3 text-sm"
                                                        />
                                                    )}
                                                </div>
                                                <div className="flex flex-col gap-1">
                                    <span className="font-medium text-color-200 tracking-wide">
                                        {t('send at')}
                                    </span>
                                                    <span className="ml-3 text-color-300 tracking-wider italic">
                                        {formatSimplifyDate(e?.created, 'fullTime')}
                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </DrawDialog>
                            )
                        })}

                        {/* Chỉ hiển thị "Xem thêm/ít" khi có hơn 2 item */}
                        {hasMore && (
                            <span
                                className="flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                                onClick={() => toggle()}>
                                <span className="text-xs italic">
                                    {isToggle ? t('see less') : t('see more')}
                                </span>
                                <FiChevronsRight size={13} className="my-auto"/>
                            </span>
                        )}
                    </div>
                )}

                {churchModal}
            </div>
        </WrapperBlockSider>
    )
}

const OrganizationInfo = ({Wrapper = FlexCol}) => {
    const {organization} = useContext(OrganizationContainerContext)
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const [isToggle, toggle] = useToggle(true)

    const {about, description, categories = []} = organization

    if (_.isEmpty(organization)) return null

    return (
        <Wrapper className="items-start gap-6 pb-20">
            {/* Tôn chỉ - Đặc sủng */}
            {renderIf(
                description,
                <div className="text-sm text-color-300 tracking-wide leading-relaxed">
                    {description}
                </div>
            )}

            {/* Categories */}
            {Number(categories?.length) > 0 && (
                <div className="flex flex-wrap gap-2">
                    {categories.map(renderCategoryLink)}
                </div>
            )}

            {/* Về chúng tôi */}
            {!isRawContentEmpty(about) && (
                <div className="w-full flex flex-col gap-3">
                    <div className="flex items-center gap-3">
                        {/* Bỏ uppercase, dùng font-semibold thay font-bold */}
                        <h3 className="font-semibold text-base text-gray-700 tracking-wide">
                            {t('about us')}
                        </h3>
                        <div className="flex-1 border-b border-color-50"/>
                        <div
                            onClick={() => toggle()}
                            className="p-2 flex flex-center hover:background-200 text-color-400 hover:text-color-100 rounded-lg cursor-pointer">
                            {/* Fix: BsCaretLeftFill → BsCaretUpFill khi đang mở */}
                            {isToggle
                                ? <BsCaretUpFill size={12}/>
                                : <BsCaretDownFill size={12}/>
                            }
                        </div>
                    </div>
                    {isToggle && (
                        <CustomEditorRenderer
                            rawValue={about}
                            className="border-transparent ml-2 text-sm"
                        />
                    )}
                </div>
            )}

            {
                !isLg && (
                    <OrganizationChurchOrAnnouncement/>
                )
            }
            {
                !isLg && (
                    <OrganizationUpcomingTimetableBlock/>
                )
            }
            {
                !isLg && (
                    <OrganizationUpcomingEventBlock/>
                )
            }
            {
                !isLg && (
                    <OrganizationShopsBlock/>
                )
            }

            {/* Cập nhật tin tức */}
            <OrganizationNews
                sample={3}
                Footer={withProps({
                    pathname: getLinkToDetail(organization) + '/news',
                })(({pathname}) =>
                    createPagerFooter({
                        to: pathname,
                        description: 'You can click "See more" to see this full information',
                    })
                )}
                Wrapper={withProps({
                    title: 'news update',
                })(HeaderItemInfo)}
            />
        </Wrapper>
    )
}

export default OrganizationInfo
